module.exports = __webpack_public_path__ + "icon_truck.png?628282ba66b638afbe8eb67b1a4c0f24";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_truck.png
// module id = 231
// module chunks = 0